import { useQueueWorkflowStore } from "@elixir/stores";
import { Drawer, notification, Tabs } from "antd";
import { DrawerHeaderUi, PrimaryButton, SecondaryButton } from "ui";
import EditQueue from "./edit-queue";
import usePatchUpdateWorkflowView from "../../../apis/tryst/workflow-view/use-patch-update-workflow-view";
import { WORKFLOW_VIEW_POPUP_STATE } from "@elixir/types";
import { getFilterExpressionFromOptions } from "@elixir/utils";

const EditFilters = () => {
  const setPopupState = useQueueWorkflowStore(
    (state) => state.setCreateViewPopupState
  );
  const clearSelectedPopupData = useQueueWorkflowStore(
    (state) => state.clearSelectedPopupData
  );
  const setViewData = useQueueWorkflowStore((state) => state.setViewData);
  const viewName = useQueueWorkflowStore((state) => state.viewName);
  const selectedFiltersOptions = useQueueWorkflowStore(
    (state) => state.selectedFiltersOptions
  );
  const viewData = useQueueWorkflowStore((state) => state.viewData);
  const isViewEdited = useQueueWorkflowStore((state) => state.isViewEdited);
  const { mutateAsync: patchUpdateWorkflowView } = usePatchUpdateWorkflowView();

  const handleEditView = async () => {
    const filterExpression = getFilterExpressionFromOptions(
      selectedFiltersOptions
    );
    const { success, error } = await patchUpdateWorkflowView({
      view_id: viewData?.viewId!,
      data: {
        name: viewName,
        filterExpression,
      },
    });
    if (success) {
      notification.success({
        message: "View updated successfully!",
        placement: "bottomRight",
      });
      setPopupState(WORKFLOW_VIEW_POPUP_STATE.VIEW_QUEUES);
      clearSelectedPopupData();
    } else {
      notification.error({
        message: error || "Error occurred while updating view!",
        placement: "bottomRight",
      });
    }
  };

  const handleClose = () => {
    setPopupState(WORKFLOW_VIEW_POPUP_STATE.VIEW_QUEUES);
    clearSelectedPopupData();
    setViewData(undefined);
  };

  return (
    <Drawer
      bodyStyle={{ padding: 0 }}
      closable={false}
      placement={"right"}
      onClose={handleClose}
      open={true}
      width={880}
      extra={null}
      destroyOnClose={true}
      footer={
        <div className="dr-flex dr-flex-row dr-justify-end dr-gap-x-16">
          <SecondaryButton title="Cancel" onClick={handleClose} />
          <PrimaryButton
            title="Save"
            onClick={handleEditView}
            isDisabled={!isViewEdited}
          />
        </div>
      }
    >
      <DrawerHeaderUi
        title="Edit queue"
        onClose={handleClose}
        extraClassname="dr-border-b dr-border-darwin-neutral-200"
      />
      <Tabs defaultActiveKey="edit_queue" className="px-16 dr-tabs">
        <Tabs.TabPane tab="Edit queue" key="edit_queue">
          <EditQueue />
        </Tabs.TabPane>
        {/* <Tabs.TabPane tab="Customise queue card" key="customise_queue_card">
          <></>
        </Tabs.TabPane> */}
      </Tabs>
    </Drawer>
  );
};

export default EditFilters;
